var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-bar'),(_vm.isLogged)?_c('router-view'):_vm._e(),_c('toast'),_c('compatible-browser'),(!_vm.isLogged)?_c('login-popup'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }